export const getApiUrl = (location = window.location, environment = process.env.NODE_ENV) => {
  if (environment === 'development') {
    return `${location.protocol}//${location.hostname}:3000`;
  }

  // Only the new domain has a same-origin /api proxy. Existing installed PWAs
  // keep using Cloud Run directly until their owners choose to migrate.
  if (location.origin === 'https://golf.juanjorc.com') return location.origin;
  return 'https://golf-webapp-back-411772435736.europe-west9.run.app';
};

const getHoleImagesBaseUrl = () => {
  return process.env.REACT_APP_HOLE_IMAGES_BASE_URL || 'https://storage.googleapis.com/tarjetavirutal.firebasestorage.app/hole_images';
};

const config = {
  apiUrl: getApiUrl(),
  holeImagesBaseUrl: getHoleImagesBaseUrl(),
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
};

export default config;
